import React, { useEffect, useState } from "react";
import { Panel, PanelGroup } from "react-bootstrap";
import PanelBody from "react-bootstrap/lib/PanelBody";
import PanelHeading from "react-bootstrap/lib/PanelHeading";
import PanelTitle from "react-bootstrap/lib/PanelTitle";
import { DEFAULT_EMAIL_FIELDS } from "../../../../constant/registrationFields";

const PlayerEmbedCode = ({eventKey, isRegistrationTypeEmail, widgetKey, privateKey = '', registrationFields = []}) => {
    const [fields, setFields] = useState([]);

    useEffect(() => {
        if (!registrationFields?.length) return;

        setFields([
            ...(isRegistrationTypeEmail ? DEFAULT_EMAIL_FIELDS : []),
            ...registrationFields.map(({field}) => field)
        ]);
    }, [registrationFields]);

    return (
        <PanelGroup
            accordion
            id="integration-code"
        >
            <Panel eventKey="integration-code">
                <PanelHeading>
                    <PanelTitle toggle>
                        Код для интеграции плеера с сайтом
                    </PanelTitle>
                </PanelHeading>
                <PanelBody collapsible>
                    <pre style={{ whiteSpace: "initial" }}>
                        &lt;?php
                        <br />
                        $eventKey = "{eventKey}"; // Уникальный ключ трансляции
                        {isRegistrationTypeEmail && (
                            <>
                                <br />
                                $privateKey = "{privateKey}"; // Приватный ключ организации
                            </>
                        )}
                        <br />
                        $userName = "..."; // Имя пользователя
                        <br />
                        $userRegistrationData = &#91;
                        <br />
                        {fields?.map((field) => (
                            <span key={field.name} style={{marginLeft: '20px'}}>
                                "{field.name}" =&gt; "...", // {field?.label_ru}
                                <br />
                            </span>
                        ))}
                        &#93;;
                        <br />
                        {isRegistrationTypeEmail && (
                            <>
                                ksort($userRegistrationData);<br />
                                $checkSum = hash_hmac('sha256', json_encode($userRegistrationData), $privateKey);<br />
                                $userRegistrationData['checkSum'] = $checkSum;<br />
                            </>
                        )}
                        ?&gt;
                        <br />
                        &lt;script
                        src="https://broadcast.comdi.com/widget/static/js/embed-player.js"
                        {isRegistrationTypeEmail
                            ? <>
                                &nbsp;data-comdi-event="&lt;?=$eventKey?&gt;"
                            </>
                            : <>
                                &nbsp;data-eventKey="{eventKey}"
                                &nbsp;data-widgetKey="{widgetKey}"
                            </>
                        }
                        &nbsp;data-login="&lt;?=$userName?&gt;"
                        data-registration="&lt;?=htmlspecialchars(json_encode($userRegistrationData), ENT_QUOTES)?&gt;"
                        <br />
                        &gt;&lt;/script&gt;
                    </pre>
                </PanelBody>
            </Panel>
        </PanelGroup>
    );
};

export default PlayerEmbedCode;
